"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _index = _interopRequireDefault(require("@/components/Tinymce/index"));
var leaseApi = _interopRequireWildcard(require("@/api/leaseApi.js"));
var _validate = require("@/utils/validate");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    Tinymce: _index.default
  },
  props: {
    dialogEditData: {
      default: null,
      type: Object
    }
  },
  watch: {
    dialogEditData: {
      handler: function handler(newVal) {
        this.initFormScene(newVal);
      },
      immediate: true
    }
  },
  data: function data() {
    return {
      loading: false,
      isEdit: false,
      pram: {
        maxLeaseDuration: null,
        paymentMethod: 'offline',
        leaseRules: '',
        id: null,
        // 新增违约金配置字段（按天）
        penaltyFreeDays: '',
        // 提前xx天免违约金
        penaltyAmountPerDay: '',
        // 每逾期1天xx元
        penaltyDesc: ''
      }
    };
  },
  methods: {
    initFormScene: function initFormScene() {
      var _this = this;
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.dialogEditData;
      if (data && data.id) {
        this.isEdit = true;
        this.$nextTick(function () {
          _this.pram = {
            id: data.id,
            maxLeaseDuration: data.maxLeaseDuration,
            paymentMethod: data.paymentMethod,
            leaseRules: (data.leaseRules || '').toString(),
            // 初始化违约金配置字段，兼容后端返回值
            penaltyFreeDays: data.penaltyFreeDays,
            penaltyAmountPerDay: data.penaltyAmountPerDay,
            penaltyDesc: data.penaltyDesc
          };
        });
      } else {
        this.isEdit = false;
        this.pram = {
          maxLeaseDuration: null,
          paymentMethod: null,
          leaseRules: '',
          id: null,
          // 新增字段默认值
          penaltyFreeDays: null,
          penaltyAmountPerDay: null,
          penaltyDesc: ''
        };
      }
    },
    handerSubmit: (0, _validate.Debounce)(function (form) {
      var _this2 = this;
      this.$refs[form].validate(function (valid) {
        if (!valid) return;
        _this2.handlerUpdate();
      });
    }, 500),
    handlerUpdate: function handlerUpdate() {
      var _this3 = this;
      this.loading = true;
      var apiFunc = this.isEdit ? leaseApi.updateLeaseConfig : leaseApi.addLeaseConfig;
      apiFunc(this.pram).then(function () {
        _this3.$message.success(_this3.isEdit ? '修改租赁配置成功！' : '新增租赁配置成功！');
        _this3.loading = false;
        _this3.$emit('refresh');
        _this3.$emit('close-dialog');
      }).catch(function () {
        _this3.loading = false;
        _this3.$message.error('操作失败，请重试！');
      });
    }
  }
};